const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20PV%20screenshot%20style%20scene%2C%20fantasy%20battle%20with%20magical%20effects%2C%20warm%20orange%20and%20golden%20lighting%2C%20cinematic%20composition%2C%20high%20quality%20Japanese%20animation%20style%2C%20dramatic%20action%20pose&width=800&height=450&seq=media-01&orientation=landscape',
    title: '《修仙狂徒》动画化PV首发',
    desc: '万众期待的修仙狂徒动画化正式启动，首支预告PV带来震撼视觉体验。',
    duration: '1:32',
    tag: 'PV预告',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20interview%20scene%20with%20manga%20artist%20at%20drawing%20desk%2C%20warm%20studio%20lighting%2C%20sketches%20on%20wall%2C%20creative%20atmosphere%2C%20soft%20colors%2C%20documentary%20style%20composition&width=800&height=450&seq=media-02&orientation=landscape',
    title: '漫画家专访：《暗夜猎手》作者',
    desc: '独家专访韩漫人气作者，揭秘暗夜猎手创作背后的故事与灵感来源。',
    duration: '8:15',
    tag: '独家专访',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Manga%20style%20tutorial%20scene%20showing%20drawing%20process%2C%20step%20by%20step%20illustration%2C%20warm%20desk%20lighting%2C%20art%20supplies%2C%20educational%20vibe%2C%20clean%20flat%20illustration%20style&width=800&height=450&seq=media-03&orientation=landscape',
    title: '漫画入门教程：从零开始学画漫画',
    desc: '零基础也能学会！专业画师手把手教你漫画分镜与人物绘制的核心技巧。',
    duration: '12:40',
    tag: '教程',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-play-circle-line"></i>
            视频
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">精彩视频</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            动画PV、作者专访、绘画教程，丰富的视频内容等你发现
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden cursor-pointer group"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ aspectRatio: '16/9' }}
                  onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-2xl md:text-3xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/60 backdrop-blur-sm text-background-50 text-xs px-2 py-0.5 rounded-md">
                  {item.duration}
                </div>
                <span className="absolute top-3 left-3 bg-accent-500/90 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}